import React from "react";
import { IconArrowBack } from "@tabler/icons";
import { Page } from "@fdoh/health-ui-react";
import { UnAuthorizedProps } from "./UnAuthorized.types";

export const UnAuthorized = (props: UnAuthorizedProps) => {
    const { title, errorMessage } = props;    

    return (
        <Page.Container>
            <Page.Body>
                <div className="flex-fill d-flex align-items-center justify-content-center">
                    <div className="container-tight py-6">
                        <div className="empty">
                            <div className="empty-icon">
                                <div className="display-4">401</div>
                            </div>
                            <p className="empty-title h3">Unauthorized: {title}</p>
                            <p className="empty-subtitle text-muted">
                                {errorMessage}
                            </p>
                            <div className="empty-action">
                                <a href="/" className="btn btn-primary">
                                    <IconArrowBack />
                                    <span className="ml-2">Return to Homepage</span>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </Page.Body>
        </Page.Container>
    );
}
export default UnAuthorized;